// @ts-nocheck 95f5b80c
import errorPanel from './errorPanel';

export { errorPanel as errorPagePanel };
